function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { Circle, Svg } from '@react-pdf/renderer';
import React from 'react';
export function PrintableStepIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Circle, {
    cx: "12",
    cy: "12",
    fill: "#326ac2",
    r: "6"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: "12",
    cy: "12",
    fill: "#fff",
    r: "4"
  }));
}